"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordAltWithAnimationIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
var MBText_1 = require("../MBText");
function RecordAltWithAnimationIcon(_a) {
    var _b = _a.fill, fill = _b === void 0 ? themes_1.THEME.colors.basic.White100 : _b, _c = _a.size, size = _c === void 0 ? 20 : _c, _d = _a.playAnimation, playAnimation = _d === void 0 ? false : _d;
    return (jsx_runtime_1.jsx(StyledCircle, __assign({ fill: fill, size: size, playAnimation: playAnimation, id: "styled-circle" }, { children: jsx_runtime_1.jsx(RecIconText, __assign({ fontWeight: "bold", containerSize: size }, { children: "REC" }), void 0) }), void 0));
}
exports.RecordAltWithAnimationIcon = RecordAltWithAnimationIcon;
var breatheAnimation = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n0% {\n  box-shadow: 0px 0px 2px 1px #ff7b75;\n}\n50% {\n  box-shadow: 0px 0px 8px 4px #ff7b75;\n}\n100% {\n  box-shadow: 0px 0px 2px 1px #ff7b75;\n}\n"], ["\n0% {\n  box-shadow: 0px 0px 2px 1px #ff7b75;\n}\n50% {\n  box-shadow: 0px 0px 8px 4px #ff7b75;\n}\n100% {\n  box-shadow: 0px 0px 2px 1px #ff7b75;\n}\n"])));
var StyledCircle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: 0.2s all ease-in-out;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: ", ";\n  border: ", "px solid #000;\n\n  animation: ", "\n    2s ease-in-out infinite;\n"], ["\n  transition: 0.2s all ease-in-out;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: ",
    ";\n  border: ", "px solid #000;\n\n  animation: ", "\n    2s ease-in-out infinite;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size / 2;
}, function (_a) {
    var playAnimation = _a.playAnimation, fill = _a.fill;
    return playAnimation ? '#ff7b75' : fill;
}, function (_a) {
    var size = _a.size;
    return (size >= 32 ? 1.5 : 1);
}, function (_a) {
    var playAnimation = _a.playAnimation;
    return (playAnimation ? breatheAnimation : null);
});
var RecIconText = styled_components_1.default(MBText_1.MBText)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    font-size: ", "px;\n  }\n"], ["\n  && {\n    font-size: ", "px;\n  }\n"])), function (_a) {
    var containerSize = _a.containerSize;
    return (containerSize / 20) * 8;
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=RecordAltWithAnimationIcon.js.map